import { render, staticRenderFns } from "./icpFooter.vue?vue&type=template&id=5d7c36dd&scoped=true"
import script from "./icpFooter.vue?vue&type=script&lang=js"
export * from "./icpFooter.vue?vue&type=script&lang=js"
import style0 from "./icpFooter.vue?vue&type=style&index=0&id=5d7c36dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-load_294f669fab72d5cfe46d5d718e980b17/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c36dd",
  null
  
)

export default component.exports